import { isOperatorsPathname } from "./operatorsRoutes";
import { getDashboardPageTitle } from "./tools/dashboards/catalog";
import { getOkrsPageTitle } from "./tools/okrs/okrsNav";

export const DASHBOARDS_PATH = "/dashboards" as const;
export const OKRS_PATH = "/okrs" as const;

export function getAppPageTitle(pathname: string): string {
  if (pathname === "/settings/usage" || pathname.startsWith("/settings/usage/")) {
    return "Usage";
  }
  if (pathname === "/settings/account" || pathname.startsWith("/settings/account/")) {
    return "Account";
  }
  if (pathname === "/settings/admin" || pathname.startsWith("/settings/admin/")) {
    return "Admin";
  }
  if (pathname === "/settings" || pathname.startsWith("/settings/")) {
    return "Settings";
  }
  const dashboardTitle = getDashboardPageTitle(pathname);
  if (dashboardTitle) {
    return dashboardTitle;
  }
  if (isDashboardsPathname(pathname)) {
    return "Dashboards";
  }
  const okrsTitle = getOkrsPageTitle(pathname);
  if (okrsTitle) {
    return okrsTitle;
  }
  if (isOkrsPathname(pathname)) {
    return "OKRs";
  }
  if (pathname === "/" || pathname === "" || isOperatorsPathname(pathname)) {
    return "Operators";
  }
  return "Operators";
}

export function isSettingsPathname(pathname: string): boolean {
  return pathname === "/settings" || pathname.startsWith("/settings/");
}

export function isDashboardsPathname(pathname: string): boolean {
  return pathname === DASHBOARDS_PATH || pathname.startsWith(`${DASHBOARDS_PATH}/`);
}

export function isOkrsPathname(pathname: string): boolean {
  return pathname === OKRS_PATH || pathname.startsWith(`${OKRS_PATH}/`);
}

export function isAppMainFlushPathname(pathname: string): boolean {
  return (
    isOperatorsPathname(pathname) ||
    isDashboardsPathname(pathname) ||
    isOkrsPathname(pathname) ||
    isSettingsPathname(pathname)
  );
}
